import VideoTplNative from '../../../class/template/vt/VideoTplNative'
import {onBroadcastWebviewshow, onJSBridgeConnected, onWebviewshow} from "../../../api";

/**
 * 大模板 demo1 的实现
 * @type {VideoTplNative}
 */

window.MTG_LAUNCH_videoTplNative = function () {
    let videoTplNative = new VideoTplNative({})
    window.videoTplNative = videoTplNative

    // 开启 vConsole
    // videoTplNative.enableDebugMode()

    console.log('onJSBridgeConnected: listening...')
    onJSBridgeConnected((JsBridgeRes) => {
        console.warn('onJSBridgeConnected( (res) => {', {JsBridgeRes})
        videoTplNative.init({JsBridgeRes})
    })

    console.log('onBroadcastWebviewshow: listening...')
    onBroadcastWebviewshow((res) => {
        console.error('onBroadcastWebviewshow((res) => {', {res})
        videoTplNative.show(res)
    })
}